import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectProperty, setProperty, selectCapacity } from './classSlice'

const labels = [
    'clean', 'low', 'medium', 'high'
]

const TrashSlider = () => {
    let dispatch = useDispatch()
    let messiness = useSelector(selectProperty('messiness'))
    let capacity = useSelector(selectCapacity)

    let onChange = ev => dispatch(setProperty({ key: 'messiness', value: ev.target.value }))

    return (
        <div>
            <label forHtml="student-slider">
                Messiness: {labels[messiness]}
            </label>
            <br />
            <input
                id="messy-slider" type="range" name="messiness" min={0} max={3}
                onChange={onChange} value={messiness}
            />
        </div>
    )
}

export default TrashSlider